var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ1TopLeftArrowB(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 37V20h17l-7.1 7.07L56 53.17 53.17 56 27.08 29.9 20 37z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J1_Top-left_arrow_B.067e8e3b.svg";
export { SvgJ1TopLeftArrowB as ReactComponent };